<div #carouselContainer class="p-d-flex p-jc-center p-ai-center p-flex-column p-mt-3">
  <p-carousel [value]="versiones" [numVisible]="1" [numScroll]="1" [circular]="false">
    <ng-template pTemplate="item" let-version>
      <div class="carousel-item-content">
        <div class="image-container" (click)="openImage(version.url,'Versión ')">
          <img [src]="version.url" [alt]="version.version" class="product-img" />
        </div>
        <div class="version-label">{{ version.version }}</div>
      </div>
    </ng-template>
  </p-carousel>
  <div class="d-flex justify-content-end" *ngIf="versiones[0].hasSesion">
    <button class="p-button p-button-success" (click)="onSelectedMat()">Seleccionar</button>
  </div>
</div>